/// <amd-module name="Test/Analytics/TestResultsReportView/Stores/TestResultReportStore" />
import { AnalyticsExceptionType, extractODataError, recognizeAnalyticsException } from "Analytics/Common/Utilities/AnalyticsExceptionUtilities";
import * as CommonTypes from "Test/Analytics/Common/Types";
import { TestResultsGridActions } from "Test/Analytics/TestResultsGrid/Actions/TestResultsGridActions";
import { FailedTestsMetricActions } from "Test/FailedTestsMetricView/Actions/FailedTestsMetricActions";
import { PassRateChartActions } from "Test/PassRateChartView/Actions/PassRateChartActions";
import { TrendChartActions } from "Test/TrendChartView/Actions/TrendChartActions";
import { Store } from "VSS/Reflux/Store";

export interface ITestResultsReportState {
    testContext: CommonTypes.ITestContext | null;
    viewType: CommonTypes.ViewType;
    errorText?: string;
}

export class TestResultsReportStore extends Store {
    private _state: ITestResultsReportState;

    constructor(
        private _passRateChartActions: PassRateChartActions,
        private _failedTestsMetricActions: FailedTestsMetricActions,
        private _trendChartActions: TrendChartActions,
        private _detailedListActions: TestResultsGridActions
    ) {
        super("");
        this._initialize();
    }

    public getState(): ITestResultsReportState {
        return this._state;
    }

    public dispose(): void {
        this._passRateChartActions.updatePassRateChartAction.removeListener(this._onUpdatePassedRateChart);
        this._passRateChartActions.onError.removeListener(this._onError);
        this._failedTestsMetricActions.onError.removeListener(this._onError);
        this._trendChartActions.onError.removeListener(this._onError);
        this._detailedListActions.onError.removeListener(this._onError);
    }

    private _initialize(): void {
        this._state = { viewType: CommonTypes.ViewType.ReportView } as ITestResultsReportState;
        this._passRateChartActions.updatePassRateChartAction.addListener(this._onUpdatePassedRateChart);
        this._passRateChartActions.onError.addListener(this._onError);
        this._failedTestsMetricActions.onError.addListener(this._onError);
        this._trendChartActions.onError.addListener(this._onError);
        this._detailedListActions.onError.addListener(this._onError);
    }

    private _onUpdatePassedRateChart = (passedRateChartData: CommonTypes.ICardMetricsData) => {
        if (passedRateChartData) {
            if (passedRateChartData.totalCount === 0) {
                this._state.viewType = CommonTypes.ViewType.NoTestDataView;
                this.emitChanged();
            } else if (this._state.viewType !== CommonTypes.ViewType.ReportView) {
                this._state.viewType = CommonTypes.ViewType.ReportView;
                this.emitChanged();
            }
        }
    };

    private _onError = (error: Error) => {
        if (recognizeAnalyticsException(error) === AnalyticsExceptionType.DataNotReady) {
            this._state.viewType = CommonTypes.ViewType.DataNotReadyView;
        } else {
            this._state.viewType = CommonTypes.ViewType.ErrorView;
            this._state.errorText = extractODataError(error);
        }
        this.emitChanged();
    };
}
